// ======================================================================
// File Name       : ServiceUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { SELECT_BOX_DATA } from '../constants/SelectBoxData';
import { RELEASE_TARGET } from '../constants/ServiceConstant';

export function convertPublicStatus(publicStatus) {
  const publicStatusParsed = parseInt(publicStatus, 10);
  if (!isNaN(publicStatusParsed)) {
    const index = SELECT_BOX_DATA.PUBLIC_STATUS_ENTERPRISE_NOTIFICATION.findIndex(
      item => item.value === publicStatusParsed,
    );
    if (index > -1) {
      return SELECT_BOX_DATA.PUBLIC_STATUS_ENTERPRISE_NOTIFICATION[index].name || '';
    }
  }
  return '';
}

export function convertUserType(userType) {
  const userTypeParsed = parseInt(userType, 10);
  if (!isNaN(userTypeParsed)) {
    const index = SELECT_BOX_DATA.USER_TYPE.findIndex(item => item.value === userTypeParsed);
    if (index > -1) {
      return SELECT_BOX_DATA.USER_TYPE[index].name || '';
    }
  }
  return '';
}

export function convertReleaseTarget(releaseTarget) {
  const releaseTargetParsed = parseInt(releaseTarget, 10);
  if (!isNaN(releaseTargetParsed)) {
    if (releaseTargetParsed === RELEASE_TARGET.OVER_ALL) {
      return '全体';
    }
    if (releaseTargetParsed === RELEASE_TARGET.INDIVIDUAL) {
      return '個別';
    }
  }
  return '';
}

// Step SAML START
export function copyTextToClipboard(value) {
  navigator.clipboard.writeText(value);
}
// Step SAML END

// sprint_20230403 #4 START
export function getDocumentPrintingPermissionLabel(value) {
  return value ? '印刷可能' : '印刷不可';
}

export function getDocumentDownloadPermissionLabel(value) {
  return value ? 'ダウンロード可能' : 'ダウンロード不可';
}

export function getServiceDeleteFlagLabel(value) {
  return value ? '解約' : '利用中';
}

export const SERVICE_CATEGORY_STATUS = {
  DEMO: 1,
  TRIAL: 2,
  MIDDLE: 3,
  END: 4,
  END_RELATIVE: 5,
  OTHER: 6,
  EXTERNAL_LINK_1: 10,
  EXTERNAL_LINK_2: 11,
  EXTERNAL_LINK_3: 12,
};

export function getServiceCategoryStatus(status) {
  switch (status) {
    case SERVICE_CATEGORY_STATUS.DEMO:
      return 'デモ';
    case SERVICE_CATEGORY_STATUS.TRIAL:
      return 'トライアル';
    case SERVICE_CATEGORY_STATUS.MIDDLE:
      return 'ミドル';
    case SERVICE_CATEGORY_STATUS.END:
      return 'エンド';
    case SERVICE_CATEGORY_STATUS.END_RELATIVE:
      return 'エンド(相対)';
    case SERVICE_CATEGORY_STATUS.OTHER:
      return 'その他';
    case SERVICE_CATEGORY_STATUS.EXTERNAL_LINK_1:
      return '外部連携1';
    case SERVICE_CATEGORY_STATUS.EXTERNAL_LINK_2:
      return '外部連携2';
    case SERVICE_CATEGORY_STATUS.EXTERNAL_LINK_3:
      return '外部連携3';
    default:
      return '';
  }
}
// sprint_20230403 #4 END
